import { ca } from '@cian/analytics';

import { TJsonQuery } from '../../../../../packages/JsonQuery';
import { FDealType, FOfferType } from '../../../../utils/category';
import { getMessageKeyParameter } from './getMessageKeyParameter';

export function trackRosbankPilotBannerShown(searchParams: TJsonQuery, offerType: FOfferType, serpType: FDealType) {
  ca('eventSite', {
    action: 'show_sopr',
    category: 'Alternative',
    label: 'Banner',
    name: 'oldevent',
    page: {
      extra: {
        banner_location: 'Listing',
        message_key: getMessageKeyParameter(offerType, serpType),
      },
    },
    sc: searchParams,
  });
}

export function trackRosbankPilotBannerClicked(searchParams: TJsonQuery, offerType: FOfferType, serpType: FDealType) {
  ca('eventSite', {
    action: 'click_sopr',
    category: 'Alternative',
    label: 'Banner',
    name: 'oldevent',
    page: {
      extra: {
        banner_location: 'Listing',
        message_key: getMessageKeyParameter(offerType, serpType),
      },
    },
    sc: searchParams,
  });
}
